var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDpd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "DPD_Black",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64.4 75",
    style: {
      enableBackground: "new 0 0 64.4 75"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n  .st0{fill:url(#SVGID_1_);}\n ")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 853.55,
    y1: -312.2374,
    x2: 995.8518,
    y2: -431.6428,
    gradientTransform: "matrix(0.229 0 0 0.229 -195.1519 135.152)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A90034"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2717,
    style: {
      stopColor: "#BB0033"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7226,
    style: {
      stopColor: "#D30032"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DC0032"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44.7,33.5c-0.3,0.2-0.8,0.2-1.1,0l-1.7-1c-0.1-0.1-0.3-0.2-0.4-0.4c0,0,0,0,0,0c-0.1-0.2-0.2-0.4-0.2-0.5l0-2 c0-0.3,0.2-0.8,0.5-0.9l20.9-12.2l-29.4-16C33,0.1,32.6,0,32.2,0c-0.4,0-0.9,0.1-1.2,0.3l-29.4,16l32.9,19.2 c0.3,0.2,0.5,0.6,0.5,0.9v27.9c0,0.4-0.3,0.8-0.6,0.9l-1.8,1c-0.1,0.1-0.3,0.1-0.5,0.1c0,0,0,0,0,0c-0.2,0-0.4,0-0.6-0.1l-1.8-1 c-0.3-0.2-0.5-0.6-0.5-0.9l0-24.9c0-0.2-0.1-0.4-0.3-0.5L0,22v33.1c0,0.7,0.5,1.7,1.2,2L31,74.7c0.3,0.2,0.7,0.3,1.2,0.3 c0.4,0,0.8-0.1,1.2-0.3l29.9-17.6c0.6-0.4,1.2-1.3,1.2-2V22L44.7,33.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDpd);
export default __webpack_public_path__ + "static/media/dpd.2d48eba4961afa9f9786022f176d0b06.svg";
export { ForwardRef as ReactComponent };